import React from "react";
import { Reveal, Counter, SplitWords } from "../motionHelpers";

const STATS = [
  { to: 4, suffix: "", label: "Pickleball Courts" },
  { to: 1, suffix: "", label: "Panoramic Padel Court" },
  { to: 16, suffix: "h", label: "Open Play, Daily" },
  { to: 1, suffix: "M+", label: "DUPR Players Worldwide" },
];

export default function Stats() {
  return (
    <section className="d2-bg py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-16">
          <h2 className="font-display uppercase text-white text-5xl md:text-7xl leading-[0.9]">
            <SplitWords text="A supreme place" className="block" />
            <SplitWords text="to play the game" className="block text-sc-lime" delay={0.15} />
          </h2>
          <Reveal delay={0.1}>
            <p className="text-white/60 text-lg font-grotesk">
              The first purpose-built multi-court pickleball &amp; padel facility in Parañaque — climate-controlled, tournament-grade, and built for community. Come rally with us.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="bg-[#06170f]">
              <div className="p-8 md:p-10">
                <div className="font-display text-6xl md:text-7xl text-sc-lime leading-none">
                  <Counter to={s.to} suffix={s.suffix} />
                </div>
                <div className="font-grotesk uppercase tracking-widest text-xs text-white/50 mt-3">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
